var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-row',{staticClass:"page-header py-4",attrs:{"no-gutters":""}},[_c('div',{staticClass:"col-12 text-sm-left mb-0"},[_c('span',{staticClass:"text-uppercase page-subtitle d-block"},[_vm._v(_vm._s(_vm.title))]),_c('h3',{staticClass:"page-title d-inline"},[_vm._v(_vm._s(_vm.subTitle))]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }